import * as R from 'ramda'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Loading from '../components/loading'
import { CATEGORY_DETAIL_PAGE_TYPE } from '../constants/enums/common.enum.constant'
import CategoryDetailTitleBar from '../containers/category/CategoryDetailTitleBar'
import CategoryForm from '../containers/category/CategoryForm'
import HorizontalGridDivider from '../containers/horizontalGridDivider'
import SideMenu from '../containers/sideMenu'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivider from '../containers/verticalGridDivider'
import {
  CategoryDetailInterface,
  CategoryFormInterface
} from '../interfaces/category'
import {
  createCategoryRequest,
  getCategoryDetailRequest,
  updateCategoryRequest
} from '../redux/category/actions'
import {
  getCategoryDetail,
  getIsCreateOrUpdatingCategory,
  getIsFetchingCategoryDetail
} from '../redux/category/selectors'
import { createAndUpdateCategoryFormToApiConvertor } from '../utils/service'

const emptyCategoryDetail: CategoryDetailInterface = {
  categoryId: '',
  sequentialNo: 0,
  name: '',
  type: '',
  remark: '',
  blogUrl: ''
}

const CategoryDetail = ({
  match: {
    params: { categoryId: id }
  }
}: {
  match: {
    params: {
      categoryId: string
    }
  }
  [key: string]: any
}) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const checkPageType = (
    type: keyof typeof CATEGORY_DETAIL_PAGE_TYPE
  ): ((path: string) => boolean) =>
    R.compose(R.equals(type) as any, R.head, R.reverse as any, R.split('/'))
  const newForm = checkPageType(CATEGORY_DETAIL_PAGE_TYPE.create)(pathname)

  const categoryDetail = newForm
    ? emptyCategoryDetail
    : (useSelector(getCategoryDetail) as CategoryDetailInterface)

  const isFetchingCategoryDetail = useSelector(getIsFetchingCategoryDetail)
  const isCreateOrUpdatingCategory = useSelector(getIsCreateOrUpdatingCategory)

  const formHandlers = {
    createCategory: (createdCategory: CategoryFormInterface): void => {
      dispatch(
        createCategoryRequest(
          createAndUpdateCategoryFormToApiConvertor(createdCategory)
        )
      )
    },
    updateCategory: (updatedCategory: CategoryFormInterface): void => {
      dispatch(
        updateCategoryRequest({
          categoryId: categoryDetail.categoryId,
          categoryDetail: createAndUpdateCategoryFormToApiConvertor(
            updatedCategory
          )
        })
      )
    }
  }

  useEffect(() => {
    if (!newForm) {
      dispatch(getCategoryDetailRequest(id))
    }
  }, [])

  return (
    <HorizontalGridDivider>
      <SideMenu />
      <VerticalGridDivider>
        <TopBar />
        <StyledMain>
          <CategoryDetailTitleBar
            title={'Category Detail'}
            detail={categoryDetail}
            newForm={newForm}
          />
          {isFetchingCategoryDetail || isCreateOrUpdatingCategory ? (
            <Loading />
          ) : (
            <CategoryForm
              categoryDetail={categoryDetail}
              newForm={newForm}
              formHandlers={formHandlers}
            />
          )}
        </StyledMain>
      </VerticalGridDivider>
    </HorizontalGridDivider>
  )
}

export default CategoryDetail
